import React from "react";
import {Layout} from "./components/Layout/Layout";
import "./css/App.css";
import {useNavigate} from "react-router-dom";

const App: React.FC = () => {
    let navigate = useNavigate();
    return (
    <>
      <Layout navigate={navigate}/>
    </>
  );
};

export default App;
